export const ProductCategoryActionTypes = {
    ADD_PRODUCT: 'ADD_PRODUCT',
    ADD_BUTTON: "ADD_BUTTON"
};